// 编辑抽屉里“删除”的目标（决策 D180）。
import type { DeleteCheck, Removable } from "./master";

/** 要删除的实体：名词与名字用于标题和提示，check 与 remove 绑定好了标识。 */
export interface DeleteTarget {
  noun: string;
  name: string;
  check: () => Promise<DeleteCheck>;
  remove: () => Promise<void>;
  /** 删除后要重新拉取的查询键前缀。 */
  invalidate: string[];
  /** 删除成功、抽屉关闭之后再做的事，例如详情页回到列表。 */
  after?: () => void;
}

/** 把可删除实体的一行包成 DeleteTarget；key 是 id，号码前缀是 prefix。 */
export function deleteTarget(noun: string, name: string, entity: Removable, key: number | string, invalidate: string[]): DeleteTarget {
  return { noun, name, check: () => entity.deleteCheck(key), remove: () => entity.remove(key), invalidate };
}
